import { render, staticRenderFns } from "./PromptBook.vue?vue&type=template&id=d518968e&scoped=true&"
import script from "./PromptBook.vue?vue&type=script&lang=js&"
export * from "./PromptBook.vue?vue&type=script&lang=js&"
import style0 from "./PromptBook.vue?vue&type=style&index=0&id=d518968e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d518968e",
  null
  
)

export default component.exports